(function () {
  const STORAGE_KEY = "7u_tracking_v1";
  const SESSION_TIMEOUT_MINUTES = 30;

  function getNowIso() {
    return new Date().toISOString();
  }

  function getNowMs() {
    return Date.now();
  }

  function getQueryParams() {
    const params = new URLSearchParams(window.location.search);

    return {
      utm_source: params.get("utm_source") || "",
      utm_medium: params.get("utm_medium") || "",
      utm_campaign: params.get("utm_campaign") || "",
      utm_term: params.get("utm_term") || "",
      utm_content: params.get("utm_content") || ""
    };
  }

  function getDeviceType() {
    const ua = navigator.userAgent || "";
    if (/tablet|ipad/i.test(ua)) return "tablet";
    if (/mobi|android|iphone/i.test(ua)) return "mobile";
    return "desktop";
  }

  function getBrowser() {
    const ua = navigator.userAgent || "";
    if (/edg/i.test(ua)) return "edge";
    if (/chrome|crios/i.test(ua) && !/edg/i.test(ua)) return "chrome";
    if (/safari/i.test(ua) && !/chrome|crios|edg/i.test(ua)) return "safari";
    if (/firefox|fxios/i.test(ua)) return "firefox";
    return "other";
  }

  function getOS() {
    const ua = navigator.userAgent || "";
    if (/windows/i.test(ua)) return "windows";
    if (/mac os/i.test(ua) && !/iphone|ipad|ipod/i.test(ua)) return "macos";
    if (/iphone|ipad|ipod/i.test(ua)) return "ios";
    if (/android/i.test(ua)) return "android";
    if (/linux/i.test(ua)) return "linux";
    return "other";
  }

  function generateId(prefix) {
    if (window.crypto && crypto.randomUUID) {
      return prefix + "_" + crypto.randomUUID();
    }
    return prefix + "_" + Math.random().toString(36).slice(2) + Date.now().toString(36);
  }

  function safeParse(value) {
    try {
      return JSON.parse(value || "{}");
    } catch (e) {
      return {};
    }
  }

  function loadStoredData() {
    try {
      return safeParse(localStorage.getItem(STORAGE_KEY));
    } catch (e) {
      return {};
    }
  }

  function saveStoredData(data) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    } catch (e) {
      console.error("Erro ao salvar tracking no localStorage", e);
    }
  }

  function getPagePathWithQuery() {
    return window.location.pathname + window.location.search;
  }

  function getExternalReferrer() {
    try {
      const ref = document.referrer || "";
      if (!ref) return "";

      const refUrl = new URL(ref);
      if (refUrl.hostname === window.location.hostname) return "";

      return ref;
    } catch (e) {
      return document.referrer || "";
    }
  }

  function isSessionExpired(stored) {
    const lastActivityAt = Number(stored.last_activity_ts || 0);
    if (!lastActivityAt) return true;

    const timeoutMs = SESSION_TIMEOUT_MINUTES * 60 * 1000;
    return getNowMs() - lastActivityAt > timeoutMs;
  }

  function getSessionId(stored) {
    if (!stored.session_id) return generateId("sess");
    if (isSessionExpired(stored)) return generateId("sess");
    return stored.session_id;
  }

  function buildTrackingData() {
    const stored = loadStoredData();
    const query = getQueryParams();
    const nowIso = getNowIso();
    const nowMs = getNowMs();
    const currentPage = getPagePathWithQuery();
    const externalReferrer = getExternalReferrer();
    const newSessionId = getSessionId(stored);

    return {
      first_seen_at: stored.first_seen_at || nowIso,
      last_seen_at: nowIso,

      journey_id: stored.journey_id || generateId("journey"),
      session_id: newSessionId,

      session_started_at:
        newSessionId !== stored.session_id
          ? nowIso
          : stored.session_started_at || nowIso,

      last_activity_ts: nowMs,

      initial_landing_page: stored.initial_landing_page || currentPage,
      last_page: currentPage,

      initial_referrer: stored.initial_referrer || externalReferrer,
      last_referrer: document.referrer || "",

      device_type: getDeviceType(),
      browser: getBrowser(),
      os: getOS(),

      screen_resolution:
        window.screen && window.screen.width && window.screen.height
          ? window.screen.width + "x" + window.screen.height
          : "",

      viewport:
        window.innerWidth && window.innerHeight
          ? window.innerWidth + "x" + window.innerHeight
          : "",

      utm_source: query.utm_source || stored.utm_source || "",
      utm_medium: query.utm_medium || stored.utm_medium || "",
      utm_campaign: query.utm_campaign || stored.utm_campaign || "",
      utm_term: query.utm_term || stored.utm_term || "",
      utm_content: query.utm_content || stored.utm_content || ""
    };
  }

  const trackingData = buildTrackingData();
  saveStoredData(trackingData);

})();